export const Background = () => {
  return (
    <div className={`absolute -z-10 w-full h-full`}>
      {/* <div className={`bg-aqua-primary w-full h-[calc(5rem+20rem/2)]`}></div>
      <div className={`bg-gray-primary w-full h-4/6`}></div> */}
    </div>
  );
};
